module.exports = __webpack_public_path__ + "static/img/6areaB_6.6a9c873.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/6areaB_6.png
// module id = 1209
// module chunks = 1